import React, { useState } from "react";
import { compose } from "recompose";
import { Table, Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { withTable, EditDeleteButtonsModal, Page, } from "components/common";
import { Trans } from "react-i18next";
import Edit from "./Edit";
import BackButton from "./../BackButton";

export const PublicHolidayList = ({
  TableContainer,
  match,
  data,
  onDeleteItem,
  PayrollTableDataFetch,
  PayrollBulkDeleteButton,
  payroll,
  ...props
}) => {
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [listItem, setListItem] = useState([])
  const [id, setId] = useState("new")

  const updateList = async () => {
    setModal(false)
    const data = await payroll.get(`public_holidays`).get("data");
    setListItem(data)
  }


  React.useEffect(() => {
    setListItem(data.results)
  }, [data])

  return (
    <Page title="" className="inv-table">
      <BackButton />
      <h4 style={{ marginTop: "15px", marginBottom: "20px" }}><Trans>Public Holidays</Trans></h4>
      <PayrollBulkDeleteButton className="d-none" />

      <Button onClick={(e) => { toggleModal(); setId("new") }} color="success" className="bt float-left mb-4" type="add">
        <i className="fa fa-plus mr-2" aria-hidden="true"></i>
        <Trans>Add New</Trans>
      </Button>

      <TableContainer>
        <Table>
          <thead>
            <tr>
              <th sortBy="name"><Trans>Name</Trans></th>
              <th sortBy="date"><Trans>Date</Trans></th>
              <th sortBy="date"><Trans>Repeat Holiday</Trans></th>
              <th>
                <Trans>Actions</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            {listItem.map((i) => (
              <tr key={i.id}>
                <td>{i.name}</td>
                <td>{i.date}</td>
                <td>{i.public_holiday_type}</td>
                <td className="text-end text-nowrap">
                  <EditDeleteButtonsModal
                    url={match.url}
                    id={i.id}
                    onDelete={onDeleteItem}
                    onEdit={(e) => { setId(`${i.id}`); toggleModal(); }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
      <PayrollTableDataFetch />
      {console.log('idddd', id)}

      <Modal isOpen={modal} toggle={toggleModal} {...props}>
        <ModalHeader toggle={toggleModal}><Trans>Create Public Holiday</Trans></ModalHeader>
        <ModalBody>

          <Edit {...props} _payroll={payroll} updateList={updateList} id={id} />

        </ModalBody>

      </Modal>
    </Page>
  )
};

const enhance = compose(withTable({ limit: 99999, url: "public_holidays" }));

export default enhance(PublicHolidayList);
